import React from 'react';

import { app } from '../firebase';
import * as ROUTES from 'constants/routes';

const MenuTop = ({lang, user}) => {
		return (
			<div id="navbar" className="navbar navbar-default ace-save-state">
				<div className="navbar-container ace-save-state" id="navbar-container">
					<button type="button" className="navbar-toggle menu-toggler pull-left" id="menu-toggler" data-target="#sidebar">
						<span className="sr-only">Toggle sidebar</span>
	
						<span className="icon-bar"></span>
	
						<span className="icon-bar"></span>
	
						<span className="icon-bar"></span>
					</button>
	
					<div className="navbar-header pull-left">
						<a href="/" className="navbar-brand">
							<small>
								<i className="fa fa-question"></i>
								&nbsp;&nbsp;iQuestion CMS
							</small>
						</a>
					</div>
					<div className="navbar-buttons navbar-header pull-right" role="navigation">
            <ul className="nav ace-nav">
              <li className="light-blue dropdown-modal">
                <a data-toggle="dropdown" href="#" className="dropdown-toggle">
                  <img className="nav-user-photo" src={user.photoURL} alt={user.displayName} />
                  <span className="user-info">
                    <small>Привет,</small>
                    {user.displayName ? user.displayName : '-'}
                  </span>
  
                  <i className="ace-icon fa fa-caret-down"></i>
                </a>
  
                <ul className="user-menu dropdown-menu-right dropdown-menu dropdown-yellow dropdown-caret dropdown-close">
                  <li>
                    <a href={ROUTES.SETTINGS}>
                      <i className="ace-icon fa fa-cog"></i>
                      Настройки
                    </a>
                  </li>
  
                  <li className="divider"></li>
  
                  <li>
                    <a onClick={() => app.auth().signOut()}>
                      <i className="ace-icon fa fa-power-off"></i>
                      Выход
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
				</div>
			</div>	
		);
};

export default MenuTop;
